'use client';
import React, { useEffect } from 'react';

const ContactSection: React.FC = () => {
  useEffect(() => {
    // Load Tally embed script
    const existingScript = document.getElementById('tally-js');
    if (!existingScript) {
      const script = document.createElement('script');
      script.id = 'tally-js';
      script.src = 'https://tally.so/widgets/embed.js';
      script.async = true;
      script.onload = () => {
        if (typeof (window as any).Tally !== 'undefined') {
          (window as any).Tally.loadEmbeds();
        }
      };
      document.body.appendChild(script);
    } else {
      if (typeof (window as any).Tally !== 'undefined') {
        (window as any).Tally.loadEmbeds();
      }
    }
  }, []);

  return (
    <section
      id="contact"
      style={{
        backgroundColor: '#F2EDE0',
        paddingTop: '6rem',
        paddingBottom: '6rem',
        scrollMarginTop: '96px',
      }}
    >
      <div className="max-w-7xl mx-auto px-6">
        {/* Eyebrow pill */}
        <div style={{ marginBottom: '2.5rem' }}>
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.4rem',
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: 10,
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.12em',
              color: '#87926B',
              opacity: 1,
              border: '1px solid #87926B',
              borderRadius: '999px',
              padding: '0.3rem 0.85rem',
              backgroundColor: 'transparent',
            }}
          >
            GET IN TOUCH
          </span>
        </div>

        {/* Two-column: headline + intro */}
        <div
          className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16"
          style={{ marginBottom: '3.5rem' }}
        >
          {/* Headline */}
          <div>
            <h2
              style={{
                fontFamily: "'Fraunces', serif",
                fontSize: 'clamp(2rem, 4vw, 3rem)',
                fontWeight: 500,
                lineHeight: 1.15,
                letterSpacing: '-0.02em',
                color: '#1A1A1A',
                margin: 0,
              }}
            >
              Reach the research executive directly.
            </h2>
          </div>

          {/* Intro paragraph */}
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <p
              style={{
                fontFamily: "'Fraunces', serif",
                fontSize: 17,
                fontWeight: 400,
                lineHeight: 1.7,
                color: '#4A4A3A',
                margin: 0,
              }}
            >
              For municipal partnership inquiries, academic research collaboration, press requests, or general questions about the dataset, write to us. A member of the NTBI executive will respond within seven days.
            </p>
          </div>
        </div>

        {/* Tally form embed */}
        <div
          style={{
            backgroundColor: '#FAF7F0',
            borderRadius: '12px',
            border: '1px solid rgba(135, 146, 107, 0.2)',
            overflow: 'hidden',
            padding: '0.5rem',
          }}
        >
          <style>{`
            /* Tally iframe palette overrides via CSS custom properties */
            iframe[data-tally-src] {
              width: 100% !important;
              border: none !important;
              background: transparent !important;
            }
          `}</style>
          <iframe
            data-tally-src="https://tally.so/embed/xXvJx9?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
            loading="lazy"
            width="100%"
            height="400"
            frameBorder={0}
            marginHeight={0}
            marginWidth={0}
            title="NTBI Contact Form"
            style={{
              display: 'block',
              width: '100%',
              border: 'none',
              background: 'transparent',
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
